(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-addon-floating"]) return;
  try {
    
  class ProductAddonFloating extends HTMLElement {
    connectedCallback() {
      this.peek = this.querySelector('.addon-peek');
      if (!this.peek) return;

      const delay = parseInt(this.dataset.autoShowDelay || '0', 10);
      if (delay > 0) {
        this.showTimer = window.setTimeout(() => this.show(), delay);
      } else {
        requestAnimationFrame(() => this.show());
      }

      this.closeBtn = this.querySelector('[data-addon-peek-close]');
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.handleClose.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.showTimer) window.clearTimeout(this.showTimer);
    }

    show() {
      this.peek.setAttribute('data-active', '');
    }

    handleClose(event) {
      event.stopPropagation();
      this.peek.removeAttribute('data-active');
      window.setTimeout(() => {
        this.setAttribute('hidden', '');
      }, 250);
    }
  }

  if (!customElements.get('product-addon-floating')) {
    customElements.define('product-addon-floating', ProductAddonFloating);
  }

  } catch(e) { console.error(e); }
})();
})();
